"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var GraphicDesign = function GraphicDesign(_ref) {
  var borderColor = _ref.borderColor,
      offsetColor = _ref.offsetColor;
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, _react.default.createElement("path", {
    fill: offsetColor,
    d: "M79.37 383.98h96.7v87.98h-96.7zM224.1 231.53h95.98v96.46H224.1zM32.15 144.04h95.98v87.98H32.15zM352.04 32.06l47.99 23.99-47.99 24H32.12a8 8 0 01-8-8v-32a8 8 0 018-8h319.92z"
  }), _react.default.createElement("g", {
    fill: borderColor
  }, _react.default.createElement("path", {
    d: "M448.02 503.94H8.12a8 8 0 01-8-8v-367.9a8 8 0 018-8h376.4c3.96-31.52 30.93-56 63.5-56a64.06 64.06 0 0163.98 64v311.91a64.06 64.06 0 01-63.98 63.99zm-431.9-16h431.9c26.46 0 47.98-21.52 47.98-47.99s-21.52-47.98-47.98-47.98-48 21.52-48 47.98a8 8 0 11-15.99 0V136.03H16.13v351.91zm431.9-111.97c19.09 0 36.25 8.4 47.98 21.7V128.04c0-26.46-21.52-47.99-47.98-47.99s-48 21.53-48 48v269.64a63.84 63.84 0 0148-21.71z"
  }), _react.default.createElement("path", {
    d: "M392.15 224H8a8 8 0 110-15.99h384.15a8 8 0 110 16zm0 95.98H8a8 8 0 110-16h384.15a8 8 0 110 16zm0 95.98H8a8 8 0 110-16h384.15a8 8 0 110 16z"
  }), _react.default.createElement("path", {
    d: "M104.1 503.94a8 8 0 01-8-8v-367.9a8 8 0 1116 0v367.9a8 8 0 01-8 8zm95.98 0a8 8 0 01-8-8v-367.9a8 8 0 1116 0v367.9a8 8 0 01-8 8zm95.97 0a8 8 0 01-8-8v-367.9a8 8 0 1116 0v367.9a8 8 0 01-8 8zM472.01 264a8.42 8.42 0 01-5.68-2.32c-1.44-1.52-2.32-3.6-2.32-5.68s.88-4.17 2.32-5.68a8.37 8.37 0 0111.36 0c1.44 1.51 2.32 3.6 2.32 5.68s-.88 4.16-2.32 5.68A8.46 8.46 0 01472 264zm0-32a8 8 0 01-8-8v-95.97a8 8 0 1116 0v95.98a8 8 0 01-8 8zM352.04 72.05H32.12c-8.82 0-16-7.18-16-16v-32c0-8.81 7.18-15.99 16-15.99h319.92c1.24 0 2.47.29 3.58.84l47.98 24a8 8 0 010 14.31l-47.99 24a8.04 8.04 0 01-3.57.84zm-319.92-48v32h318.03l32-16-32-16H32.12z"
  }), _react.default.createElement("path", {
    d: "M344.04 72.05a8 8 0 01-8-8V16.06a8 8 0 1116 0v47.99a8 8 0 01-8 8zm-191.95 31.99H88.11c-13.23 0-24-10.77-24-24V16.06a8 8 0 1116 0v63.98a8 8 0 008 8h63.98a8 8 0 110 16z"
  }), _react.default.createElement("path", {
    d: "M104.1 48.05a8.42 8.42 0 01-5.68-2.32c-1.44-1.52-2.32-3.6-2.32-5.68s.88-4.16 2.32-5.68c3.04-2.95 8.4-2.95 11.36 0a8.23 8.23 0 012.32 5.68c0 2.16-.88 4.16-2.32 5.68a8.3 8.3 0 01-5.68 2.32zm32 0a8 8 0 01-5.69-2.4 7.95 7.95 0 01-2.31-5.6 8.4 8.4 0 012.32-5.67c2.95-2.96 8.4-2.96 11.35 0a8 8 0 01-.08 11.36 7.96 7.96 0 01-5.6 2.31zm31.99 0a8 8 0 01-5.68-2.4 7.95 7.95 0 01-2.32-5.6 8.4 8.4 0 012.32-5.67c2.96-2.96 8.32-2.96 11.35 0 1.44 1.5 2.32 3.6 2.32 5.67s-.88 4.16-2.32 5.68a8.46 8.46 0 01-5.67 2.32z"
  })));
};

GraphicDesign.propTypes = {
  borderColor: _propTypes.default.string,
  offsetColor: _propTypes.default.string
};
GraphicDesign.defaultProps = {
  borderColor: "#242523",
  offsetColor: "#63DC3E"
};
var _default = GraphicDesign;
exports.default = _default;